import { Dropdown, Form, Nav } from 'react-bootstrap';
import styles from '../../styles/NavBar.module.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { GetProductsByCategory } from '../../hooks/GetProductsByCategory';
import { Group1Schema } from '../../models/Group1Items';
import { Group2Schema } from '../../models/Group2Items';
import { User } from '../../models/user';

interface SearchBoxProps {
    group1: Group1Schema[],
    group2: Group2Schema[],
    loggedInUser: User | null,
};

const SearchBox = ( {loggedInUser, group1, group2}: SearchBoxProps) => {

    const { products } = GetProductsByCategory(loggedInUser);

    const [searchTerm, setSearchTerm] = useState('');
    const [searchToggle, setSearchToggle] = useState(false);
    const [filteredData, setFilteredData] = useState(products);
    const [searchIsFocused, setSearchIsFocused] = useState(false);

    const handleSearch = (e:string) => {
       setSearchTerm(e);

        if (e.length >= 3) {
            // Escape special characters in the search term
            const escapedTerm = e.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

            // Create a case-insensitive regular expression for the search term
            const regex = new RegExp(escapedTerm, 'i');

            // Filter the data based on the search term
            const filtered = products.filter(item => {
                // Convert both the search term and the item to normalized form
                const normalizedTerm = item.NAME.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                const normalizedItem = item.NAME.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                return regex.test(normalizedTerm) || regex.test(normalizedItem);
            });
            setFilteredData(filtered);
            setSearchToggle(true);
        } else {
            setFilteredData([]);
            setSearchToggle(false);
        }
    };

    return (
        <Nav className={`${styles.NavSearch} order-2 order-sm-2 ms-0 me-auto`}>
                        <Form className="d-flex py-2">
                        <Form.Control
                            type="search"
                            name="search"
                            value={searchTerm}
                            placeholder="Αναζήτηση"
                            className="me-auto"
                            aria-label="Αναζήτηση"
                            onChange={(e) => { handleSearch(e.target.value) }}
                            onFocus={() => setSearchIsFocused(true)}
                            onBlur={() => setSearchIsFocused(true)}
                        />
                        </Form>
                    {searchIsFocused && searchToggle && searchTerm && filteredData.length > 0 && (
                        <Dropdown.Menu show className={`${styles.searchResultBox} overflow-hidden`} onClick={() => { setSearchToggle(false) }}>
                            {filteredData.map((item, index) => (
                                <Dropdown.Item as={Link} to={`/g2/${item.GROUP2}`} state={{ g1ParentName: group1.find(grp1 => Number(grp1.CODE) === Number(item.GROUP1))?.NAME, g1ParentId: item.GROUP1, g2ParentName: group2.find(grp2 => Number(grp2.ID) === Number(item.GROUP2))?.NAME }} key={item.ID} className={`overflow-hidden ${styles.searchResultItem}`}>{item.NAME}</Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    )}
        </Nav>
    );
};

export default SearchBox;